import React from 'react';
import { ApolloError } from '@apollo/client';

import { SiteManagementLocationFragment } from '@occc/graphql';
import { useGetLocationSummaryQuery } from '@occc-app/dataAccessLayer/location/queries';

export interface ILocationContextValue {
  loading: boolean;
  error?: ApolloError;
  location: SiteManagementLocationFragment | null;
}

export interface ILocationContextProvider {
  children?: React.ReactNode;
  locationId: string;
}

export const LocationContext = React.createContext<ILocationContextValue>({
  location: null,
  loading: false,
});

const LocationProvider: React.FC<ILocationContextProvider> = (props) => {
  const { loading, error, data } = useGetLocationSummaryQuery(props.locationId);

  return (
    <LocationContext.Provider value={{ location: data.location, loading, error }}>
      {props.children}
    </LocationContext.Provider>
  );
};

export default LocationProvider;
